export const COLORS = {
  PURPLE: "PURPLE",
  GRADIENT: "GRADIENT"
};

export type Color = keyof typeof COLORS;
